import React from "react";
import Image from "next/image";
import Section from "../layout/Section";

const FunAtWork: React.FC = () => {
    return (
        <>
            <Section id="funAtWork" className="bg-light-green pt-50 pb-50">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 col-sm-12 col-12">
                            <div className="row">
                                <div className="col-lg-6 d-none d-xl-block">
                                    <Image
                                        height={200}
                                        width={350}
                                        className="mb-10 bdr-16"
                                        src="/assets/imgs/paginas/over-ons/partyOpOffice.webp"
                                        alt="Party op office"/>
                                    <Image
                                        height={200}
                                        width={350}
                                        className="bdr-16"
                                        src="/assets/imgs/paginas/over-ons/carting.webp"
                                        alt="Carting met collega"/>
                                </div>
                                <div className="col-lg-6 text-center">
                                    <Image
                                        height={420}
                                        width={350}
                                        className="bdr-16"
                                        src="/assets/imgs/paginas/over-ons/hivefive.webp"
                                        alt="Hive five"/>
                                </div>
                            </div>
                        </div>
                        <div className="mt-30 mt-lg-0 col-lg-6 col-sm-12 col-12">
                            <h2 className="text-heading-2 text-lg-start text-center">
                                Fun at Work
                            </h2>
                            <p className="text-inter-lg text-lg-start text-center mt-30">
                                De beste prestaties komen naar boven, wanneer mensen plezier hebben in wat ze doen en er
                                een vriendencultuur heerst binnen de organisatie.
                            </p>
                            <br/>
                            <p className="text-inter-lg text-lg-start text-center">
                                <strong>‘Work hard, play hard’</strong> is zeker van toepassing bij Cohesian.
                            </p>
                            <br/>
                            <p className="text-inter-lg text-lg-start text-center">
                                Wij nemen geregeld de tijd om de <strong>Fun factor</strong> te verhogen, door de
                                werkomgeving aangenamer
                                te maken, toffe teamleden aan te trekken en vooral ook leuke activeiten te organiseren.
                            </p>
                        </div>
                    </div>
                </div>
            </Section>
        </>
    );
};

export default FunAtWork;
